import { GridOptions } from 'ag-grid-community';
// import { customAgGridTheme } from './custom-theme';
import { customAgGridTheme } from './custom-theme';
import { defaultSideBarPanels } from './default-aggrid.sidepanels';

export const defaultGridOptions: GridOptions = {
    cellSelection: {
        handle: {
            mode: 'range'
        }
    },
    defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false,
        floatingFilter: true,
        suppressHeaderMenuButton: true,
        floatingFilterComponentParams: {
            suppressFloatingFilterButton: false
        },
        enableValue: false,
        filter: true,
        filterParams: {
            maxNumConditions: 1
        }
    },
    enableCharts: true,
    suppressAggFuncInHeader: true,
    // rowSelection: {
    //     mode: 'multiRow'
    // },
    rowDragManaged: true,
    headerHeight: 35,
    rowHeight: 24,
    animateRows: true,
    statusBar: {
        statusPanels: [
            {
                statusPanel: 'agTotalAndFilteredRowCountComponent',
                align: 'left'
            },
            {
                statusPanel: 'agTotalRowCountComponent',
                align: 'center'
            },
            { statusPanel: 'agFilteredRowCountComponent' },
            { statusPanel: 'agSelectedRowCountComponent' },
            { statusPanel: 'agAggregationComponent' }
        ]
    },
    icons: {
        valuePanel: '<i class="pi pi-sliders-h"/>'
    },
    rowGroupPanelShow: 'always',
    multiSortKey: 'ctrl',
    autoGroupColumnDef: {
        headerName: ''
    },
    groupDefaultExpanded: -1,
    suppressLastEmptyLineOnPaste: true,
    rowData: [],
    columnDefs: [],
    sideBar: {
        toolPanels: [...defaultSideBarPanels]
    },
    skipHeaderOnAutoSize: false,
    theme: customAgGridTheme
};
